module.exports = __webpack_public_path__ + "static/tanker-da79c526e79e6677c21614cb2902ffe0.jpg";